import { useMemo } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { listTransactions, type ListTransactionsParams } from '../api/transactions';
import { getTokenStore } from '../api/token-store';

export function useMyTransactions(params: ListTransactionsParams = {}) {
  const cleanParams = useMemo(() => {
    const cleaned: ListTransactionsParams = {};
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined) {
        (cleaned as any)[key] = value;
      }
    }
    return cleaned;
  }, [JSON.stringify(params)]);

  return useQuery({
    queryKey: ['transactions', cleanParams],
    queryFn: () => listTransactions(cleanParams),
    enabled: !!getTokenStore().getAccessToken(),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}
